import { Component, Input } from '@angular/core';

@Component({
  selector: 'modulo-eventos',
  templateUrl: './eventos.component.html',
  styleUrls: ['./eventos.component.scss']
})
export class EventosComponent {

  @Input("data") data; 
  @Input("template") template       = null; 
  @Input("classCustom") classCustom = "";
  public dataItem:any = {
    nome: ""
  }
  public eventos:any = [];
  
  constructor(){ }

  /**
   * 
   * @param text 
   * 
   * 
   */
  search(text:any){

    let t    = this.dataItem.nome.toLowerCase();
    let data = [];

    for (let index = 0;index < this.data.eventos.length;index++) {
      
      if(this.data.eventos[index].nome.toLowerCase().includes(t)){
        data.push(this.data.eventos[index]);
      }
      
    }

    this.eventos = data;

  }
  /**
  * 
  * Inicializa as Funções
  * 
  */
  ngOnInit(){
    this.eventos = Object.assign(this.data.eventos,{});
  }

}
